import request from '@/utils/request';
// 预设原因列表
export const getReasonList = (params: any) =>
  request({
    url: 'AppearReason/appearReasonList',
    method: 'get',
    params
  });

// 添加标签
export const addReason = (data: any) =>
  request({
    url: 'AppearReason/appearReason',
    method: 'POST',
    data
  });

// 删除标签
export const deleteReason = (data: any) =>
  request({
    url: 'AppearReason/appearReason',
    method: 'DELETE',
    data
  });

// 编辑标签
export const modifyReason = (data: any) =>
  request({
    url: 'AppearReason/appearReason',
    method: 'PUT',
    data
  });
  // 列表
export const getVariousTagsList = (params: any) =>
  request({
    url: 'VariousTags/tagsList',
    method: 'get',
    params
  });

// 添加
export const addVariousTags = (data: any) =>
  request({
    url: 'VariousTags/tags',
    method: 'POST',
    data
  });

// 删除
export const deleteVariousTags = (data: any) =>
  request({
    url: 'VariousTags/tags',
    method: 'DELETE',
    data
  });

// 编辑评价标签
export const modifyVariousTags = (data: any) =>
  request({
    url: 'VariousTags/tags',
    method: 'PUT',
    data
  });
